
import './App.css';
import { BrowserRouter, Routes,Route } from 'react-router-dom';
import Home from './Pages/Home';
import Navbar from './Components/Navbar';
import { Toaster } from 'react-hot-toast';
import { Navigate } from 'react-router-dom';
import Thankyou from './Pages/Thankyou';
function App() {
  return (
    <>
<div>
<Toaster />
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/thankyou" element={<Thankyou/>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
</div>
    </>
  );
}

export default App;
